import * as React from "react";

import { Skeleton } from "@replo/design-system/components/skeleton/Skeleton";
import { skipToken } from "@tanstack/react-query";
import useCurrentUser from "@v2/hooks/useCurrentUser";
import { affiliatesRouter } from "@v2/trpc/routes/affiliates";

export const DubDashboard = () => {
  const { user } = useCurrentUser();

  const { data: tokenData } = (affiliatesRouter as any).getEmbedToken.useQuery(
    user ? {} : skipToken,
  );

  if (!tokenData?.publicToken) {
    return (
      <div className="w-full flex flex-col gap-4">
        <Skeleton className="w-full h-[242px] bg-gradient-to-r from-[#F8FAFC] to-[#ECECEC]" />

        <div className="flex gap-4 w-full">
          <Skeleton className="w-full md:w-[738px] h-[117px] bg-gradient-to-r from-[#F8FAFC] to-[#ECECEC]" />
          <Skeleton className="hidden md:block flex-1 h-[117px] bg-gradient-to-r from-[#F8FAFC] to-[#ECECEC]" />
        </div>

        <Skeleton className="w-full md:w-[493px] h-[19px] bg-gradient-to-r from-[#F8FAFC] to-[#ECECEC]" />

        <div className="flex flex-col md:flex-row gap-4 w-full">
          <Skeleton className="flex-1 h-[200px] bg-gradient-to-r from-[#F8FAFC] to-[#ECECEC]" />
          <Skeleton className="flex-1 h-[200px] bg-gradient-to-r from-[#F8FAFC] to-[#ECECEC]" />
          <Skeleton className="flex-1 h-[200px] bg-gradient-to-r from-[#F8FAFC] to-[#ECECEC]" />
        </div>
      </div>
    );
  }

  return (
    <div className="w-full flex-1 min-h-0">
      <iframe
        src={`https://app.dub.co/embed/referrals?token=${tokenData.publicToken}`}
        allow="clipboard-write"
        referrerPolicy="origin"
        className="h-full w-full border-0"
        title="Dub Referrals Dashboard"
      />
    </div>
  );
};
